String.prototype.has = function(i) {
  return this.indexOf(i) > -1;
};
function jsmin(i, j, g) {
  function k(a) {
    return a != h && (o.has(a) || a.charCodeAt(0) > 126);
  }

  function c() {
    var a = m;
    if (c.i == c.l) return h;
    m = h;
    if (a == h) {
      a = j.charAt(c.i);
      ++c.i;
    }
    if (a >= " " || a == "\n") return a;
    if (a == "\r") return "\n";
    return " ";
  }

  function l() {
    return (m = c());
  }

  function n() {
    var a = c();
    if (a == "/")
      switch (l()) {
        case "/":
          for (;;) {
            a = c();
            if (a <= "\n") return a;
          }
          break;
        case "*":
          c();
          if (l() == "!")
            for (var e = "/*!"; ; ) {
              a = c();
              switch (a) {
                case "*":
                  if (l() == "/") {
                    c();
                    return e + "*/";
                  }
                  break;
                case h:
                  throw "Error: Unterminated comment.";
                default:
                  e += a;
              }
            }
          else
            for (;;)
              switch (c()) {
                case "*":
                  if (l() == "/") {
                    c();
                    return " ";
                  }
                  break;
                case h:
                  throw "Error: Unterminated comment.";
              }
          break;
        default:
          return a;
      }
    return a;
  }

  function d(a) {
    var e = [];
    a == 1 && e.push(b);
    if (a < 3) {
      b = f;
      if (b == "'" || b == '"')
        for (;;) {
          e.push(b);
          b = c();
          if (b == f) break;
          if (b <= "\n") throw "Error: unterminated string literal: " + b;
          if (b == "\\") {
            e.push(b);
            b = c();
          }
        }
    }
    f = n();
    if (f == "/" && "(,=:[!&|".has(b)) {
      e.push(b);
      for (e.push(f); ; ) {
        b = c();
        if (b == "/") break;
        else if (b == "\\") {
          e.push(b);
          b = c();
        } else if (b <= "\n")
          throw "Error: unterminated Regular Expression literal";
        e.push(b);
      }
      f = n();
    }
    return e.join("");
  }

  function p() {
    var a = [];
    b = "\n";
    for (a.push(d(3)); b != h; )
      switch (b) {
        case " ":
          k(f) ? a.push(d(1)) : a.push(d(2));
          break;
        case "\n":
          switch (f) {
            case "{":
            case "[":
            case "(":
            case "+":
            case "-":
              a.push(d(1));
              break;
            case " ":
              a.push(d(3));
              break;
            default:
              if (k(f)) a.push(d(1));
              else g == 1 && f != "\n" ? a.push(d(1)) : a.push(d(2));
          }
          break;
        default:
          switch (f) {
            case " ":
              if (k(b)) {
                a.push(d(1));
                break;
              }
              a.push(d(3));
              break;
            case "\n":
              if (g == 1 && b != "\n") a.push(d(1));
              else
                switch (b) {
                  case "}":
                  case "]":
                  case ")":
                  case "+":
                  case "-":
                  case '"':
                  case "'":
                    g == 3 ? a.push(d(3)) : a.push(d(1));
                    break;
                  default:
                    k(b) ? a.push(d(1)) : a.push(d(3));
                }
              break;
            default:
              a.push(d(1));
              break;
          }
      }
    return a.join("");
  }

  if (j === undefined) {
    j = i;
    i = "";
    g = 2;
  } else if (g === undefined || g < 1 || g > 3) g = 2;
  if (i.length > 0) i += "\n";
  var b = "",
    f = "",
    h = -1,
    o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_$\\",
    m = h;
  c.i = 0;
  c.l = j.length;
  jsmin.oldSize = j.length;
  ret = p(j);
  jsmin.newSize = ret.length;
  return i + ret;
}
